import moment from 'moment';

export default () => ({
	notifyState: [
		{ state: 0, text: 'initial state', userText: 'Sin estado' },
		{ state: 1, text: 'accepted', userText: 'Aceptado' },
		{ state: 2, text: 'denied', userText: 'Denegado' },
		{ state: 3, text: 'pending', userText: 'Pendiente' },
		{ state: 4, text: 'registered', userText: 'Registrado' },
	],
	lodgingsOfPerson: [],
	selectedService: null,
	itemEmpty: null,
	lodgingWithProblems: null,
	message: '',
	updatingService: null,
	mirrorLodging: null,
	lodgingSelect: null,
	loadingLodgings: false,
	editMode: false,
	lodgings: [],
	periods: [],
	places: [],
	lodgingPersons: [],
	rangeDatePayments: {},
	lodgingsPlace: [],
	countLogingsPlace: 0,
	rangeDate: {
		start: null,
		end: null,
	},
	startSave: false,
	selectedPlace: null,
	servicesComboBox: [],
	bottomSheet: false,
	placeUsersEmails: [],
	updateMap: false,
	firma: undefined,
	lodgingForm: undefined,
	month: moment().format('YYYY-MM'),
});
